if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}



// WEBPACK FOOTER //
// ./app/javascript/common/polyfills/forEachPolyfill.js